
///////////////////////////////////   GLOBAL VARIABLES //////////////////////////////////////////////////////////////////////




/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////// FUNCTIONS DEFINITIONS //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////// GRAB THE RELEVANT HTML PAGE ELEMENTS /////////////////////////////////////////////////////

function grabHtmlContentForChgBckgndOnScroll() {

return {
		pseudoElSun: document.querySelector(".pageMainSection > div:nth-child(4)::before"),
		pageDiv: document.querySelectorAll(".pageMainSection > div"),
		pageArticle: document.querySelectorAll(".pageMainSection article"),
		pageTot: document.querySelector(".pageMainSection"),
		headerDiv: document.getElementsByTagName("header")[0],
		navDiv: document.getElementsByTagName("nav")[0],
		symbNight: document.querySelector(".img_theme_night"),
		stairsMirroredImg: document.querySelector("#page_counseling > div:nth-of-type(4) img"),
		columnsImg_a: document.querySelectorAll(".colonnato"),
}
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



/////////////////////////// FUNCTION FOR SWAPPING DAY AND NIGHT //////////////////////////////

function swapDayAndNight() {

	const {pseudoElSun, pageDiv, pageArticle, pageTot, headerDiv, navDiv, symbNight, stairsMirroredImg, columnsImg_a} = grabHtmlContentForChgBckgndOnScroll();
	
//	console.log(headerDiv);
//	console.log(symbNight);
//	console.log(pageDiv[3]);
//	console.log(pageDiv[2]);
//	console.log(pageDiv[4]);
//	console.log(pageTot);
	
	let scrollDist;
	let maxScrollDist;
	let normScrollDist;
	let normScrollDistNightTh;
	let fade2Night;
	let fade2NightFig;

	const reElSize = /\d+\.?\d*/;
	let marginTopFirst = window.getComputedStyle(pageDiv[0]).marginTop;
	let marginTopFirst_str = marginTopFirst.match(reElSize);

	let marginTopBetween = window.getComputedStyle(pageDiv[2]).marginTop;
	let marginTopBetween_str = marginTopBetween.match(reElSize);

	let marginLeftSmall = window.getComputedStyle(pageDiv[3]).marginLeft;
	let marginLeftSmall_str = marginLeftSmall.match(reElSize);

	let scrollDistOnDivTgt;

	let centerSunset_y;
	let centerSunset_x;

	let refPosForStars;
	let deltaPosForStars;
	
	const firstSunUrlValue = getComputedStyle(document.documentElement).getPropertyValue("--contentFirstSunUrl");
	const sunUrlItValue = getComputedStyle(document.documentElement).getPropertyValue("--contentSunUrl_it");
	const sunUrlEnValue = getComputedStyle(document.documentElement).getPropertyValue("--contentSunUrl_en");
	const nightUrlItValue = getComputedStyle(document.documentElement).getPropertyValue("--nightTextUrl_it");
	const nightUrlEnValue = getComputedStyle(document.documentElement).getPropertyValue("--nightTextUrl_en");
// console.log("sunUrlItValue = " + sunUrlItValue);	
    symbNight.style.setProperty("opacity", "0");
	symbNight.style.setProperty("--nightTextUrl", "");
	pageDiv[1].style.setProperty("--contentFirstSunUrl", "");
	pageDiv[1].style.setProperty("--contentFirstSunPos", "0");
//	pageDiv[3].style.setProperty("--contentSunUrl", "url('../../data/images/sole_3.svg')");
	pageDiv[3].style.setProperty("--contentSunUrl", sunUrlItValue);
// console.log(pageDiv[3].style);
// console.log(pageDiv[3].style.getPropertyValue("--contentSunUrl"));
	pageDiv[3].style.setProperty("--contentSunPos", "0");
	
//	console.log(window.scrollY);
//	console.log(window.innerHeight);
//	console.log(pageDiv[3].getBoundingClientRect().top);
	
	let currentLang = localStorage.getItem("langSelected");
	
	if (!currentLang)
	{
		currentLang = 'italian';
	}
		
	if (currentLang==='italian')
		
//		{pageDiv[3].style.setProperty("--contentSunUrl", "url('../../data/images/soleConMsg.svg')");}
		{pageDiv[3].style.setProperty("--contentSunUrl", sunUrlItValue);}
		
	else
//		{pageDiv[3].style.setProperty("--contentSunUrl", "url('../../data/images/soleConMsg_eng.svg')");}
		{pageDiv[3].style.setProperty("--contentSunUrl", sunUrlEnValue);}

	if (window.matchMedia("(orientation: portrait)").matches)
		{
			maxScrollDist = +marginTopBetween_str + pageDiv[1].getBoundingClientRect().height;
			
			if ( window.scrollY + window.innerHeight >= pageDiv[1].getBoundingClientRect().top + window.scrollY )
				{
//				pageDiv[1].style.setProperty("--contentFirstSunUrl", "url('../../data/images/sole.svg')");
				pageDiv[1].style.setProperty("--contentFirstSunUrl", firstSunUrlValue);

				scrollDist = (+marginTopBetween_str + pageDiv[1].getBoundingClientRect().height + 
				( pageDiv[1].getBoundingClientRect().top - window.innerHeight*0.5 ));

				normScrollDist = (1 - ( Math.min( Math.max((scrollDist/maxScrollDist), 0) , 1) )) *100;
				
				normScrollDistNightTh = 76/2;
				
				fade2Night = Math.min(Math.max( ( (100 - normScrollDist) / (100 - normScrollDistNightTh)), 0) , 1);
				
				pageDiv[1].style.setProperty("--contentFirstSunPos", `${normScrollDist}%`);
				}
				pageDiv[1].style.setProperty("--contentFirstSunHeight", `calc(100% - (${fade2Night}*100)%)`);
		}
	
// el.getBoundingClientRect().top measures the distance between the top of element "el" and the top of the window:
// thus, when scrolling the document the position indicated by el.getBoundingClientRect().top changes --> if we want to get 
// the absolute position within the page of the top edge of element "el", the window.scrollTop/scrollY value shall be added 
// to el.getBoundingClientRect().top. The total height of the page would be given by document.body.scrollHeight.

// Here the following is implemented: a fixed position in the window is taken as reference position 
// (for ex. half the window height) - window.innerHeight*0.5 - and when the target object gets higher than this reference position by scrolling 
// the page down the target action is applied: this happens when the scrolled amount scrollY + the half window height 
// reaches the absolute position of the target object in the page (i.e. el.getBoundingClientRect().top + window.scrollY)
		
	if ( window.scrollY + (window.innerHeight*0.5) >= pageDiv[2].getBoundingClientRect().top + window.scrollY )
	{
		
		if (window.matchMedia("(orientation: landscape)").matches)
			{
				/* maxScrollDist = Math.max((+marginTopBetween_str + pageDiv[2].getBoundingClientRect().height - window.innerHeight*0.25), 0); */
			maxScrollDist = +marginTopBetween_str + pageDiv[2].getBoundingClientRect().height;
			console.log(maxScrollDist);
			console.log(scrollDist);
			console.log(normScrollDist);
			
			scrollDist = (+marginTopBetween_str + pageDiv[2].getBoundingClientRect().height + 
			( pageDiv[2].getBoundingClientRect().top - window.innerHeight*0.5 ));
			
			normScrollDist = (1 - ( Math.min( Math.max((scrollDist/maxScrollDist), 0) , 1) )) *100;
// console.log(normScrollDist);
			
			normScrollDistNightTh = 76;
			}
			
		else
			{
			maxScrollDist = (+marginTopBetween_str)*2 + pageDiv[3].getBoundingClientRect().height*1.5;
			scrollDist = ( (+marginTopBetween_str)*2 + pageDiv[3].getBoundingClientRect().height*1.5 + 
			( pageDiv[3].getBoundingClientRect().top - (pageDiv[3].getBoundingClientRect().height*0.5 + window.innerHeight*0.5) ) );
			
			normScrollDist = (1 - ( Math.min( Math.max( (scrollDist/(0.5*maxScrollDist)), 0 ) , 2) )) *100;
			console.log(normScrollDist);
			
			normScrollDistNightTh = 76/2;
			}
		
		pageDiv[3].style.setProperty("--contentSunPos", `${normScrollDist}%`);

// console.log(pageDiv[3].style);
		/* pseudoElSun.style.setProperty("height", `100% - ${normScrollDist}%`); */
		/* pseudoElSun.style.setProperty("height", "100%"); */
		/* pageTot.style.backgroundImage ="linear-gradient(45deg, rgba(var(--pageBckGndColorRed), var(--pageBckGndColorGreen), var(--pageBckGndColorBlue), 0.7), 10%, \
		rgba(var(--ToColorRed), var(--ToColorGreen), var(--ToColorBlue), 0.7) ), url('../../data/images/cielo.jpg')"; */
		pageTot.style.backgroundImage ="revert-layer";
		pageTot.style.setProperty("background-attachment", "revert-layer");
		stairsMirroredImg.style.setProperty("opacity", "revert-layer");
		for (let ind=0; ind<pageArticle.length; ind++)
			{
				pageArticle[ind].style.setProperty("color","revert-layer");
			}

	if (window.matchMedia("(orientation: landscape)").matches)
		{
		/* y position of the sun within svgFile : center = 24; radius = 10; marginTop of svg file = 8 --> center point of the sun disc = 8+24 = 32 */	
		/* height of the svg file = 108; center of sun in % of file height= 32/108 = 0.296*/

	/* 	centerSunset_y = Math.max( 
		( ( +marginTopFirst_str + pageDiv[0].getBoundingClientRect().height + +marginTopBetween_str + pageDiv[3].getBoundingClientRect().height*0.24 
		- ( Math.min( (pageDiv[3].getBoundingClientRect().top - window.innerHeight*0.5), 0) ) ) / 
		pageTot.getBoundingClientRect().height )*100, 
		0); */
		
		/* TEST */
		centerSunset_y = Math.max( ( (pageDiv[4].getBoundingClientRect().top + window.scrollY - headerDiv.getBoundingClientRect().height) / 
		pageTot.getBoundingClientRect().height )*100, 
		0);
		/* TEST */

// console.log(centerSunset_y);
// console.log(headerDiv.getBoundingClientRect().height);

		/* x position of the sun within pageDive[2] : center = 20%; radius = 10%; marginLeft of svg file = 12%--> center point of the sun disc = (20%+12%)/112 = 28.57%*/	
		centerSunset_x = Math.max( ((+marginLeftSmall_str + pageDiv[3].getBoundingClientRect().width*0.286) / pageTot.getBoundingClientRect().width)*100, 0);

// console.log(centerSunset_x);

		/* y position of the sun within svgFile : center = 24; radius = 10; marginTop of svg file = 8 --> lowest point of the sun disc = 8+24+10 = 42*/
		/* height of the svg file = 108; center of lowset position of sun in % of file height= 42/108 = 0.39*/

		/* normScrollDist goes from 0 to 100; if screen orientation = landscape, when normScrollDist moves between 76 and 100, fade2Night moves between 1 and 0 and fade2NightFig moves between 1 and 0.5*/
		/* fade2Night = Math.min(Math.max( ( (112 - (normScrollDist + 12)) / 24), 0) , 1);
		fade2NightFig = Math.min(Math.max( ( (124 - (normScrollDist + 12)) / 24), 0) , 1); */
		
		fade2Night = Math.min(Math.max( ( (100 - normScrollDist) / (100 - normScrollDistNightTh)), 0) , 1);
		fade2NightFig = Math.min(Math.max( ( (124 - normScrollDist) / ((100 - normScrollDistNightTh)/2) ), 0) , 1);
		}
	
	else
		{
		/* centerSunset_y = Math.max( 
		( ( +marginTopFirst_str + pageDiv[0].getBoundingClientRect().height + +marginTopBetween_str + pageDiv[1].getBoundingClientRect().height +
		+marginTopBetween_str + pageDiv[2].getBoundingClientRect().height +
		+marginTopBetween_str + pageDiv[3].getBoundingClientRect().height*0.24 
		- ( Math.min( (pageDiv[3].getBoundingClientRect().top - window.innerHeight*0.5), 0) ) ) / 
		pageTot.getBoundingClientRect().height )*100, 
		0); */
		
		/* TEST */
		/* centerSunset_y = Math.max( 
		( ( +marginTopFirst_str + pageDiv[0].getBoundingClientRect().height + +marginTopBetween_str + pageDiv[1].getBoundingClientRect().height +
		+marginTopBetween_str + pageDiv[2].getBoundingClientRect().height + +marginTopBetween_str + 
		pageDiv[3].getBoundingClientRect().height +  +marginTopBetween_str) / 
		pageTot.getBoundingClientRect().height )*100, 
		0); */
		centerSunset_y = Math.max( ( (pageDiv[4].getBoundingClientRect().top + window.scrollY - headerDiv.getBoundingClientRect().height) / 
		pageTot.getBoundingClientRect().height )*100, 
		0);
		/* TEST */
		
		/* x position of the sun within pageDiv[3] : center = 20%/2 = 10%; radius = 10%/2 = 5%; marginLeft of svg file = 12%/2; width of svg file = 112%/2 = 61% */
		/* --> center point of the sun disc = (10%+6%)/61 = 26.23%*/	
		centerSunset_x = Math.max( ((+marginLeftSmall_str + pageDiv[3].getBoundingClientRect().width*0.262) / pageTot.getBoundingClientRect().width)*100, 0);
		
		/* if screen orientation = portrait, when normScrollDist moves between 76/2=38 and 100, fade2Night moves between 1 and 0 and fade2NightFig moves between 1 and 0.5*/
		/* fade2Night = Math.min(Math.max( ( (112 - (normScrollDist + 12)) / 62), 0) , 1);
		fade2NightFig = Math.min(Math.max( ( (118 - normScrollDist) / 30), 0) , 1); */
		
		fade2Night = Math.min(Math.max( ( (100 - normScrollDist) / (100 - normScrollDistNightTh)), 0) , 1);
		fade2NightFig = Math.min(Math.max( ( (124 - normScrollDist) / ((100 - normScrollDistNightTh)/2) ), 0) , 1);
		}
	/* TEST */
	pageDiv[3].style.setProperty("--contentSunHeight", `calc(100% - (${fade2Night}*100)%)`);
	/* TEST */
	// console.log(fade2Night);
	// console.log(fade2NightFig);

	refPosForStars = ( (window.scrollY + pageDiv[4].getBoundingClientRect().top) / pageTot.getBoundingClientRect().height )*100;
	deltaPosForStars = ( window.innerHeight / pageTot.getBoundingClientRect().height )*100;
	// console.log(refPosForStars);
	// console.log(window.innerHeight*0.5);

	if (normScrollDist >= normScrollDistNightTh)
		{
/* Amber #FFBF00 rgb(255,191,0) / #ffa948 rgb(255,169,72) / #a64510 rgb(166,69,16)/ Sunset orange #FA5F55 rgb(250,95,85) / Dark blue #00008B / Midnight blue #191970 */
		pageTot.style.setProperty("background-image", 
		`radial-gradient(ellipse 300% 75% at ${centerSunset_x}% ${centerSunset_y}%, 
		rgba(255,191,0,0.2) 0 ${fade2Night*10}%, rgb(255,169,72) ${fade2Night*50}%, 
		rgb(166,69,16) ${fade2Night*100}%, rgb(15, 15, 67.2) ${fade2Night*150}%)`);
		
		/* stairsMirroredImg.style.setProperty("visibility", "hidden"); */
		
		symbNight.style.setProperty("display", "block");
		symbNight.style.setProperty("opacity", `${(1-fade2NightFig)*100}%`);
		
		if (normScrollDist>=100)
			{
			/* if (window.matchMedia("(orientation: portrait)").matches)
				{ */
				symbNight.style.setProperty("display", "block");
				/* } */
		symbNight.style.setProperty("opacity", "1"); 
		pageDiv[3].style.setProperty("--contentSunUrl", "");
		
		if (currentLang==='italian')
//			{symbNight.style.setProperty("--nightTextUrl", "url('../../data/images/arco_notte.svg')");}
			{symbNight.style.setProperty("--nightTextUrl", nightUrlItValue);}
		else
//			{symbNight.style.setProperty("--nightTextUrl", "url('../../data/images/arco_notte_eng.svg')");}
			{symbNight.style.setProperty("--nightTextUrl", nightUrlEnValue);}
		
// console.log(symbNight.style); 
		
			if (window.matchMedia("(orientation: landscape)").matches)
				{
				pageTot.style.setProperty("background-image", 
				`radial-gradient(circle at 10% ${refPosForStars - deltaPosForStars*0.25}%, white 0% 0.1%, transparent 0.5%), 
				radial-gradient(circle at 30% ${refPosForStars - deltaPosForStars*0.1}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 15% ${refPosForStars - deltaPosForStars*0.4}%, white 0% 0.1%, transparent 0.5%), 
				radial-gradient(circle at 20% ${refPosForStars - deltaPosForStars*0.3}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 1% ${refPosForStars + deltaPosForStars*0.4}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 90% ${refPosForStars + deltaPosForStars*0.3}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 97% ${refPosForStars + deltaPosForStars*0.6}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 98% ${refPosForStars - deltaPosForStars*0.2}%, white 0% 0.1%, transparent 0.5%),
				linear-gradient(to right, rgb(15, 15, 67.2) 0% 100%)`);
				pageTot.style.setProperty("background-attachment", "initial");
				
					for (let ind=0; ind<pageArticle.length; ind++)
					{
						pageArticle[ind].style.setProperty("color","beige");
						console.log(pageArticle[ind]);
						console.log(pageArticle[ind].style);
					}
			}	
				
			else 
				{
				
				pageTot.style.setProperty("background-image", 
				`radial-gradient(circle at 10% ${refPosForStars - deltaPosForStars*0.25}%, white 0% 0.1%, transparent 0.5%), 
				radial-gradient(circle at 30% ${refPosForStars - deltaPosForStars*0.1}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 50% ${refPosForStars - deltaPosForStars*0.25}%, white 0% 0.1%, transparent 0.5%), 
				radial-gradient(circle at 25% ${refPosForStars - deltaPosForStars*0.3}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 1% ${refPosForStars + deltaPosForStars*0.4}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 90% ${refPosForStars + deltaPosForStars*0.3}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 97% ${refPosForStars + deltaPosForStars*0.6}%, white 0% 0.1%, transparent 0.5%),
				radial-gradient(circle at 97% ${refPosForStars + deltaPosForStars*0.2}%, white 0% 0.1%, transparent 0.5%),
				linear-gradient(to right, rgb(15, 15, 67.2) 0% 100%)`);
				
				pageTot.style.setProperty("background-attachment", "initial");}

			for (let indCol = 0; indCol< columnsImg_a.length; indCol++)
				{
					columnsImg_a[indCol].style.setProperty("opacity", "0.4");
				}
			// console.log(window.getComputedStyle(columnsImg_a[1]));
			stairsMirroredImg.style.setProperty("opacity", "0.6");
			}
		}
	}
}
	
//////////////////////////////////////////////////// EVENT HANDLERS REGISTRATION ////////////////////////////////////
	
document.addEventListener('DOMContentLoaded', ()=> {
	
	window.addEventListener("load", swapDayAndNight);
	screen.orientation.addEventListener("change", swapDayAndNight);
	document.addEventListener("scroll", swapDayAndNight);

});